module.exports = __webpack_public_path__ + "img/linkedin.3e2f80b6.svg";